var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-index"},[_c('div',{staticClass:"nodata"},[_c('el-empty',{staticClass:"img",attrs:{"image-size":300,"description":"系统维护中","image":require('@/assets/img/maintenance.svg')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }